import { gameActionTypes } from './constants';
import { GameAction, GameState } from '../types';

const initialState: GameState = {
	loading: false,
	currentLevel: null,
	gameData: null,
	questions: [],
};

export default function laneChooserGameReducer(state: GameState = initialState, action: GameAction): GameState {
	const { type, payload } = action;
	const { gameData, currentLevel, sessionEndHref } = payload || {};

	switch (type) {
		case gameActionTypes.GET_GAME_DATA_REQUEST:
			return {
				...state,
				loading: true,
			};

		case gameActionTypes.GET_GAME_DATA_SUCCESS:
			return {
				...state,
				gameData,
				sessionEndHref: sessionEndHref ?? state.sessionEndHref,
				questions: gameData?.questions || [],
				loading: false,
			};

		case gameActionTypes.GET_GAME_DATA_ERROR:
			return {
				...state,
				loading: false,
			};

		case gameActionTypes.SET_CURRENT_LEVEL:
			return {
				...state,
				currentLevel,
			};

		case gameActionTypes.CLEAR_GAME_STATE:
			return initialState;

		default:
			return state;
	}
}
